import __get from 'lodash/get';
import __isObject from 'lodash/isObject';

const buildEditableProps = (value, editableConfig) => {
    if (!__isObject(editableConfig)) return undefined;

    if (editableConfig.type) {
        if (editableConfig.type === 'jspath' && __isObject(value) && value?.jsPath !== undefined) {
            return {
                ...editableConfig,
                value
            };
        }
        return {
            ...editableConfig,
            value,
            type: editableConfig.type || typeof value
        };
    }

    const result = {};
    Object.keys(editableConfig).forEach((key) => {
        result[key] = buildEditableProps(value?.[key], editableConfig[key]);
    });

    return result;
};

export const getEditableInfo = (newBlock, components, result, path) => {
    const c = components.find(
        (c) => c.name && c.name === newBlock.name && !['Fila', 'Columna', 'Contenidor', 'BlocREDL'].includes(c.name)
    );

    if (c) {
        const overriddenProps = {
            ...__get(c, `config.${newBlock.config || 'default'}.props`, {}),
            ...newBlock.props
        };

        const editableConfig = __get(c, 'config._editable', {});
        const editableProps = {};

        Object.keys(editableConfig).forEach((key) => {
            editableProps[key] = buildEditableProps(overriddenProps[key], editableConfig[key]);
        });

        result.push({
            name: newBlock.name,
            sources: newBlock.sources,
            editableProps,
            path
        });
    }

    if (Array.isArray(newBlock.children)) {
        newBlock.children.forEach((child, index) => {
            return getEditableInfo(child, components, result, `${path ? `${path}.children[${index}]` : `children[${index}]`}`);
        });
    }

    return result;
};
